import { GlobalPositionStrategy, Overlay, OverlayConfig } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable, Injector, TemplateRef, Type } from '@angular/core';

import { DialogComponent } from '@app/dialog/components';
import { DialogConfig, DialogRef, DIALOG_DATA } from '@app/dialog/models';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  constructor(private overlay: Overlay, private injector: Injector) {}

  public open<R = any, T = any>(
    content: string | TemplateRef<any> | Type<any>,
    config?: DialogConfig<T>
  ): DialogRef<R> {
    const configs = new OverlayConfig({
      positionStrategy: new GlobalPositionStrategy().centerHorizontally().centerVertically(),
      hasBackdrop: true,
    });

    const overlayRef = this.overlay.create(configs);
    const dialogRef = new DialogRef<R, T>(overlayRef, content, config);
    const injector = Injector.create({
      parent: this.injector,
      providers: [
        { provide: DialogRef, useValue: dialogRef },
        { provide: DIALOG_DATA, useValue: config?.data },
      ],
    });

    overlayRef.attach(new ComponentPortal(DialogComponent, null, injector));

    return dialogRef;
  }
}
